<app-toolbar></app-toolbar>
<app-header title="Datenschutzerklärung">
  <markant-button app-go-back>Zurück</markant-button>
</app-header>

<div class="cream">
  <div class="containerFooterLinks">
    <div class="containerFrame">
      <div class="containerFrameInner">
        <header>
          <h1>Datenschutzerklärung</h1>
        </header>

        <p>
          Als Anbieter dieses Service bearbeiten wir, die Markant Deutschland GmbH, Ihre personenbezogenen Daten vertraulich und entsprechend den gesetzlichen
          Datenschutzvorschriften. Die vorliegende Datenschutzerklärung erläutert Ihnen, welche Informationen wir erfassen und wie diese Informationen genutzt
          werden. Verantwortlicher und Datenschutzbeauftragter Verantwortlicher Betreiber dieser Website ist:
        </p>
        <p>
          Markant Deutschland GmbH<br />
          Hanns-Martin Schleyer-Strasse 2<br />
          77656 Offenburg<br />
          Deutschland <br />
        </p>

        <p>
          Der Datenschutzbeauftragte des Betreibers kann unter folgender E-Mail Adresse kontaktiert werden:
          <a href="mailto:datenschutzbeauftragter@de.markant.com">datenschutzbeauftragter&#64;de.markant.com</a>.
        </p>

        Aktuelle Version, Stand 28.11.2019
        <ng-container *ngTemplateOutlet="current"></ng-container>

        <ng-template #current>
          <p>&nbsp;</p>

          <h2>Allgemeine Hinweise</h2>

          <p>
            Es bestehen vielfältige Wege, mit uns Informationen auszutauschen, so können personenbezogene Daten beispielsweise per E-Mail, über ein
            Kontaktformular auf der Website, postalisch, per Telefon oder in einem persönlichen Treffen übermittelt werden.
          </p>

          <p>
            Sofern Sie uns personenbezogene Daten, wie z. B. E-Mail-Adressen, Namen, Anschriften, Bewerbungsunterlagen oder Interessenteninformationen etc. zur
            Verfügung stellen, erfolgt Ihre Preisgabe dieser Daten ausdrücklich auf freiwilliger Basis. Die Nutzung eines Kommunikationsweges mit uns stellt
            insofern die konkludente Einwilligung hierin dar, die übermittelten personenbezogenen Daten zu verarbeiten. Der Zweck der Verarbeitung richtet sich
            nach dem Anliegen der Person, z. B. der Beantwortung einer Interessentenanfrage oder der Beurteilung einer Bewerbung.
          </p>

          <p>
            Es erfolgt keine Weitergabe dieser personenbezogenen Daten an Dritte, ausgenommen sind mit uns verbundene Unternehmungen oder Dienstleister. Wir
            geben personenbezogene Daten nur an solche Dritte weiter, die sich zum vertraulichen und gesetzeskonformen Umgang mit den Daten verpflichtet haben.
          </p>

          <p>Über etwaige Änderungen der Zwecke der Datenverarbeitung werden wir die betroffenen Personen informieren.</p>

          Wir weisen darauf hin, dass die Datenübertragung im Internet (z. B. bei der Kommunikation per E-Mail) Sicherheitslücken aufweisen kann. Ein
          lückenloser Schutz der Daten vor dem Zugriff durch Dritte ist nicht möglich.

          <p>&nbsp;</p>

          <h2>Datenverarbeitung von Ansprechpartnern</h2>

          <p>Zweck der Datenverarbeitung/ Rechtsgrundlage:</p>

          <p>
            Wir verarbeiten die Kontaktdaten von Ansprechpartnern bei Start-ups, Kunden, Interessenten, Lieferanten und sonstigen Geschäftspartnern zur
            Kommunikation per E-Mail, Telefon, Telefax und Post. Rechtsgrundlage für die Datenverarbeitung ist Art. 6 Abs. 1 f) DSGVO. Unser berechtigtes
            Interesse ergibt sich hierbei aus dem Interesse, die Geschäftsbeziehung mit Start-ups, Kunden, Interessenten, Lieferanten und sonstigen
            Geschäftspartnern durchzuführen oder einzuleiten und hierbei persönlichen Kontakt mit Ansprechpartnern zu halten.
          </p>
          <p>Empfänger/ Kategorien von Empfängern:</p>
          <p>
            An unsere Händler und mit uns verbundene Unternehmungen werden Ihre Daten u.a. zur Durchführung oder Einleitung der Geschäftsbeziehung
            weitergegeben. Ausnahmsweise werden Daten in unserem Auftrag von Auftragsverarbeitern verarbeitet. Diese sind jeweils sorgfältig ausgesucht, werden
            von uns zudem auditiert und vertraglich nach Art. 28 DSGVO verpflichtet.
          </p>

          <p>Speicherdauer/ Kriterien für Festlegung der Speicherdauer:</p>
          <p>
            Personenbezogene Daten werden zum Zweck der Durchführung von Geschäftsbeziehungen solange gespeichert, wie hieran ein berechtigtes Interesse
            besteht.
          </p>

          <p>&nbsp;</p>

          <h2>Dateneingabe über unsere Website</h2>

          <p>Zweck der Datenverarbeitung/ Rechtsgrundlage:</p>

          <p>
            Wenn Sie uns personenbezogene Daten über das Registrierungsformular oder nach abgeschlossener Registrierung über Ihre Profil- oder Produktseite
            unserer Website personenbezogene Daten zukommen lassen, werden Ihre Angaben zur Vorbereitung eines Pitchs verarbeitet.
          </p>

          <p>
            Die Verarbeitung der über das Registrierungsformular oder nach abgeschlossener Registrierung über Ihre Profil- oder Produktseite unserer Website
            eingegebenen Daten erfolgt ausschließlich auf Grundlage Ihrer Einwilligung (in der EU auf Grundlage von Art. 6 Abs. 1 lit. a DSGVO). Sie können
            diese Einwilligung jederzeit widerrufen. Dazu reicht bspw. eine formlose Mitteilung per E-Mail an uns. In diesem Fall werden allerdings alle
            laufenden Aktivitäten zur Vorbereitung eines Pitchs von uns gestoppt. Die Rechtmäßigkeit der bis zum Widerruf erfolgten Datenverarbeitungsvorgänge
            bleibt vom Widerruf unberührt.
          </p>

          <p>Empfänger/ Kategorien von Empfängern:</p>

          <p>
            An unsere Händler und mit uns verbundene Unternehmungen werden Ihre Daten u.a. zur Durchführung oder Einleitung der Geschäftsbeziehung
            weitergegeben. Ausnahmsweise werden Daten in unserem Auftrag von Auftragsverarbeitern verarbeitet. Diese sind jeweils sorgfältig ausgesucht, werden
            von uns zudem auditiert und vertraglich nach Art. 28 DSGVO verpflichtet.
          </p>

          <p>Speicherdauer/ Kriterien für Festlegung der Speicherdauer:</p>
          <p>
            Die von Ihnen im Kontaktformular eingegebenen Daten werden von uns gespeichert, bis Sie uns zur Löschung auffordern, Ihre Einwilligung zur
            Speicherung widerrufen oder der Zweck für die Datenspeicherung entfällt (z. B. nach abgeschlossener Bearbeitung). Vorbehalten bleibt die längere
            Speicherung aufgrund spezialgesetzlicher Bestimmungen oder aufgrund drohender oder nicht abgeschlossener Rechtsstreitigkeiten.
          </p>

          <p>&nbsp;</p>

          <h2>Newsletter</h2>

          <p>Zweck der Datenverarbeitung/ Rechtsgrundlage:</p>

          <p>
            Wenn Sie den auf der Website angebotenen Newsletter beziehen möchten, benötigen wir von Ihnen eine E-Mail-Adresse sowie Informationen, welche uns
            die Überprüfung gestatten, dass Sie der Inhaber der angegebenen E-Mail-Adresse sind und mit dem Empfang des Newsletters einverstanden sind
            (Einwilligung). Weitere Daten werden nicht bzw. nur auf freiwilliger Basis erhoben.
          </p>

          <p>Empfänger/ Kategorien von Empfängern:</p>
          <p>
            Die Verarbeitung der personenbezogenen Daten erfolgt somit ausschließlich auf Grundlage Ihrer Einwilligung (in der EU auf Grundlage von Art. 6 Abs.
            1 lit. a DSGVO).
          </p>

          <p>Speicherdauer/ Kriterien für Festlegung der Speicherdauer:</p>
          <p>
            Personenbezogene Daten werden zum Zweck des Versendens der Newsletter solange gespeichert bis sie den Newsletter abbestellen oder uns bis Sie uns
            zur Löschung auffordern soweit die Daten nicht zu anderen Verarbeitungsvorgängen benötigt werden, für die wir Ihre Einwilligung besitzen
          </p>

          <p>&nbsp;</p>

          <h2>Mailjet</h2>
          <p>
            Wir nutzen Mailjet für den Versand von E-Mails. Anbieter von Mailjet ist (SAS Mailjet, 13-13bis, Rue de l’Aubrac –75012 Paris, Frankreich). Die
            dafür geltende Datenschutzrichtlinien von Mailjet finden Sie unter
            <a href="https://www.mailjet.de/privacy-policy/">https://www.mailjet.de/privacy-policy/</a>.
          </p>

          <p>
            Der Versanddienstleister kann Ihre Daten in pseudonymer Form, d.h. ohne Zuordnung zu einem Nutzer, zur Optimierung oder Verbesserung der eigenen
            Services nutzen, z.B. zur technischen Optimierung des Versandes und der Darstellung der Newsletter oder für statistische Zwecke verwenden. Der
            Versanddienstleister nutzt Ihre Daten ausschließlich im Rahmen der Auftragsverarbeitung für den Verantwortlichen und nicht, um Sie selbst
            anzuschreiben oder um die Daten an Dritte weiterzugeben.
          </p>

          <p>&nbsp;</p>

          <h2>Nutzung von Cookies</h2>
          <p>
            Unsere Website verwendet teilweise so genannte Cookies. Cookies dienen dazu, unser Angebot nutzerfreundlicher, effektiver und sicherer zu machen.
            Cookies sind Kennungen, die ein Webserver an Ihren Computer senden kann, um ihn für die Dauer des Besuches zu identifizieren.
          </p>
          <p>
            Die meisten der von uns verwendeten Cookies sind so genannte „Session-Cookies“. Sie werden nach Ende Ihres Besuchs automatisch gelöscht. Andere
            Cookies bleiben auf Ihrem Endgerät gespeichert, bis Sie diese löschen. Diese Cookies ermöglichen es uns, Ihren Browser beim nächsten Besuch
            wiederzuerkennen.
          </p>
          <p>
            Sie können Ihren Browser so einstellen, dass Sie über das Setzen von Cookies informiert werden und Cookies nur im Einzelfall erlauben, die Annahme
            von Cookies für bestimmte Fälle oder generell ausschließen oder das automatische Löschen der Cookies beim Schließen des Browsers aktivieren. Ferner
            können bereits gesetzte Cookies mittels Browser oder anderer Softwareprogramme gelöscht werden. Bei der Deaktivierung von Cookies kann die
            Funktionalität dieser Website eingeschränkt sein.
          </p>
          <p>
            Die Rechtmäßigkeit der Verwendung von Cookies ergibt sich in der EU auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO. Wir haben ein berechtigtes
            Interesse an der Speicherung von Cookies zur technisch fehlerfreien und optimalen Bereitstellung unserer Dienste.
          </p>

          <p>&nbsp;</p>

          <h2>Nutzung von Google Analytics</h2>
          <p>
            Unsere Website nutzt Funktionen des Webanalysedienstes Google Analytics. Anbieter von Google Analytics ist die Google Inc., 1600 Amphitheatre
            Parkway, Mountain View, CA 94043, USA. Google Analytics versendet Cookies, wodurch Informationen über Ihre Nutzung dieser Website an einen Server
            von Google in den USA übertragen und dort gespeichert werden können. Die Speicherung von Google-Analytics-Cookies erfolgt auf Grundlage von Art. 6
            Abs. 1 lit. f DSGVO. Wir haben ein berechtigtes Interesse an der Analyse des Nutzerverhaltens, um unsere Webangebote und ggf. unsere Werbung zu
            optimieren.
          </p>

          <p>&nbsp;</p>

          <h3 class="header">IP Anonymisierung</h3>
          <p>
            Wir haben auf dieser Website die Funktion IP-Anonymisierung aktiviert. Dadurch wird Ihre IP-Adresse von Google innerhalb von Mitgliedstaaten der
            Europäischen Union oder in anderen Vertragsstaaten des Abkommens über den Europäischen Wirtschaftsraum vor der Übermittlung in die USA gekürzt. Nur
            in Ausnahmefällen wird die volle IP-Adresse an einen Server von Google in den USA übertragen und dort gekürzt. Google wird diese Informationen in
            unserem Auftrag nutzen, um Ihre Nutzung der Website auszuwerten, um Reports über die Websiteaktivitäten zusammenzustellen und um weitere mit der
            Websitenutzung und der Internetnutzung verbundene Dienstleistungen gegenüber uns als Websitebetreiber zu erbringen. Die im Rahmen von Google
            Analytics von Ihrem Browser übermittelte IP-Adresse wird nicht mit anderen Daten von Google zusammengeführt.
          </p>

          <p>&nbsp;</p>

          <h3>Browser Plugin</h3>
          <p>
            Sie können die Speicherung der Cookies durch eine entsprechende Einstellung Ihrer Browser-Software verhindern; wir weisen Sie jedoch darauf hin,
            dass Sie in diesem Fall gegebenenfalls nicht sämtliche Funktionen dieser Website vollumfänglich nutzen können. Sie können darüber hinaus die
            Erfassung der durch den Cookie erzeugten und auf Ihre Nutzung der Website bezogenen Daten (inkl. Ihrer IP-Adresse) an Google sowie die Verarbeitung
            dieser Daten durch Google verhindern, indem Sie das unter dem folgenden Link verfügbare Browser-Plugin herunterladen und installieren:
            tools.google.com/dlpage/gaoptout?hl=de.
          </p>

          <p>&nbsp;</p>

          <h3>Widerspruch gegen Datenerfassung</h3>
          <p>
            Sie können die Erfassung Ihrer Daten durch Google Analytics verhindern, indem Sie auf folgenden Link klicken. Es wird ein Opt-Out-Cookie gesetzt,
            der die Erfassung Ihrer Daten bei zukünftigen Besuchen dieser Website verhindert: Google Analytics deaktivieren.
          </p>
          <p>
            Mehr Informationen zum Umgang mit Nutzerdaten bei Google Analytics finden Sie in der Datenschutzerklärung von Google:
            https://support.google.com/analytics/answer/6004245?hl=de
          </p>

          <p>&nbsp;</p>

          <h3>Auftragsdatenverarbeitung</h3>
          <p>
            Wir haben mit Google einen Vertrag zur Auftragsdatenverarbeitung abgeschlossen und setzen die strengen Vorgaben der deutschen Datenschutzbehörden
            bei der Nutzung von Google Analytics vollständig um.
          </p>

          <p>&nbsp;</p>

          <h2>YouTube</h2>
          <p>
            Unsere Website nutzt Plugins der von Google betriebenen Videodienstes YouTube. Betreiber von YouTube ist die YouTube, LLC, 901 Cherry Ave., San
            Bruno, CA 94066, USA. Wenn Sie eine unserer mit einem YouTube-Plugin ausgestatteten Seiten besuchen, wird eine Verbindung zu den Servern von YouTube
            hergestellt. Dabei wird dem YouTube-Server mitgeteilt, welche unserer Seiten Sie besucht haben. Wenn Sie in Ihrem YouTube-Account eingeloggt sind,
            ermöglichen Sie YouTube, Ihr Surfverhalten direkt Ihrem persönlichen Profil zuzuordnen. Dies können Sie verhindern, indem Sie sich aus Ihrem
            YouTube-Account ausloggen. Die Nutzung von YouTube erfolgt im Interesse einer ansprechenden Darstellung unserer Online-Angebote. Dies stellt ein
            berechtigtes Interesse im Sinne von Art. 6 Abs. 1 lit. f DSGVO dar. Weitere Informationen zum Umgang mit Nutzerdaten finden Sie in der
            Datenschutzerklärung von YouTube unter: www.google.de/intl/de/policies/privacy.
          </p>

          <p>&nbsp;</p>

          <h2>Google Web Fonts</h2>
          <p>
            Unsere Website nutzt zur einheitlichen Darstellung von Schriftarten so genannte Web Fonts, die von der Google LLC bereitgestellt werden. Beim Aufruf
            einer Website lädt Ihr Browser die benötigten Web Fonts in ihren Browsercache, um Texte und Schriftarten korrekt anzuzeigen.
          </p>
          <p>
            Zu diesem Zweck muss der von Ihnen verwendete Browser Verbindung zu den Servern von Google aufnehmen. Hierdurch erlangt Google Kenntnis darüber,
            dass über Ihre IP-Adresse unsere Website aufgerufen wurde. Die Nutzung von Google Web Fonts erfolgt im Interesse einer einheitlichen und
            ansprechenden Darstellung unserer Online-Angebote. Dies stellt ein berechtigtes Interesse im Sinne von Art. 6 Abs. 1 lit. f DSGVO dar. Wenn Ihr
            Browser Web Fonts nicht unterstützt, wird eine Standardschrift von Ihrem Computer genutzt. Weitere Informationen zu Google Web Fonts finden Sie
            unter https://developers.google.com/fonts/faq und in der Datenschutzerklärung von Google: https://www.google.com/policies/privacy/.
          </p>

          <p>&nbsp;</p>

          <h2>Externe Links</h2>
          <p>
            Diese Datenschutzerklärung gilt für jegliche Informationen, die wir im Rahmen Ihrer Nutzung unserer Website erhalten. Die Erklärung gilt nicht für
            solche Websites, welche unter der Kontrolle von Dritten stehen, die nicht mit uns verbunden sind und mit denen diese Website unter Umständen
            verlinkt ist („Drittwebsites“). Bitte beachten Sie die Datenschutzerklärungen der jeweiligen Drittwebsites, da wir weder für den Inhalt noch die
            Datenschutzpraxis von Drittwebsites verantwortlich sind und keinen Einfluss darauf nehmen können.
          </p>

          <p>&nbsp;</p>

          <h2>Speicherdauer</h2>
          <p>
            Wir verarbeiten personenbezogene Daten nur solange, wie dies zur Erreichung des Speicherungszwecks erforderlich ist oder durch eine Rechtsnorm
            vorgesehen ist. Entfällt der Speicherungszweck oder läuft eine gesetzliche Speicherfrist ab, werden die personenbezogenen Daten routinemäßig und
            entsprechend den gesetzlichen Vorschriften gesperrt oder gelöscht. Vorbehalten bleibt die längere Speicherung aufgrund spezialgesetzlicher
            Bestimmungen oder aufgrund drohender oder nicht abgeschlossener Rechtsstreitigkeiten.
          </p>

          <p>&nbsp;</p>

          <h2>Datenübermittlung in die Schweiz</h2>
          <p>
            Der Betreiber behält sich vor, personenbezogene Daten an die Markant AG, Schweiz zu übermitteln. Für die Schweiz besteht ein
            Angemessenheitsbeschluss der EU-Kommission (2000/518/EC), durch den festgestellt worden ist, dass die Schweiz ein angemessenes Datenschutzniveau
            besitzt, so dass eine Übermittlung personenbezogener Daten in die Schweiz gemäß Art. 45 Abs. 1 DSGVO genehmigungsfrei möglich ist.
          </p>

          <p>&nbsp;</p>

          <h2>Rechtliche Grundlagen der Verarbeitung</h2>
          <p>
            Die rechtlichen Grundlagen der Verarbeitung von personenbezogenen Daten sind zuvor jeweils genannt worden. Ergänzend weisen wir auf folgendes hin:
          </p>
          <p>
            Liegt Ihre Einwilligung – auch in konkludenter Form – vor, so erfolgt die Verarbeitung der personenbezogenen Daten aufgrund und im Rahmen dieser
            Einwilligung. Soweit die Erhebung und Verwendung von Daten aufgrund Ihrer Einwilligung erfolgt, haben Sie das Recht, eine ereilte Einwilligung
            jederzeit mit Wirkung für die Zukunft zu widerrufen, ohne dass die Rechtmäßigkeit der aufgrund der Einwilligung bis zum Widerruf erfolgten
            Verarbeitung berührt wird.
          </p>
          <p>
            Ist die Verarbeitung personenbezogener Daten zur Durchführung vorvertraglicher Maßnahmen erforderlich, z. B. bei Anfragen zu unseren Leistungen, so
            erfolgt die Verarbeitung auf Basis des Art. 6 Abs. 1 lit. b DSGVO. Ist keine der zuvor genannten Rechtsgrundlagen einschlägig, so erfolgen
            Datenverarbeitungen auf Basis des Art. 6 Abs. 1 lit. f DSGVO, nach dem es uns erlaubt ist, personenbezogene Daten zu verarbeiten, wenn die
            Verarbeitung aufgrund unseres berechtigten Interesses oder des berechtigten Interesses eines Dritten erforderlich ist, sofern Ihre Interessen,
            Grundrechte und Grundfreiheiten nicht überwiegen. Basiert die Verarbeitung personenbezogener Daten auf Art. 6 Abs. 1 lit. f DSGVO ist unser
            berechtigtes Interesse die Ausführung unserer Geschäftstätigkeit im Sinne der Gesellschafter, Mitarbeiter und Kunden.
          </p>

          <p>&nbsp;</p>

          <h2>Widerspruchsrecht</h2>
          <p>
            Sie haben das Recht, aus Gründen, die sich aus Ihrer besonderen Situation ergeben, gegen die Verarbeitung Sie betreffenden personenbezogenen Daten,
            die aufgrund von Art. 6 Abs. 1 lit. f DSGVO erfolgt, Widerspruch einzulegen. Wir verarbeiten dann die personenbezogenen Daten nicht mehr.
            Vorbehalten bleibt die längere Speicherung aufgrund spezialgesetzlicher Bestimmungen oder aufgrund drohender oder nicht abgeschlossener
            Rechtstreitigkeiten.
          </p>

          <p>&nbsp;</p>

          <h2>Rechte der betroffenen Personen</h2>
          <p>
            Sie haben das Recht, von uns eine Bestätigung darüber zu verlangen, ob Sie betreffenden personenbezogenen Daten von uns verarbeitet werden. Ist dies
            der Fall, so haben Sie ein Recht auf Auskunft betreffend Ihre personenbezogenen Daten, die von uns verarbeitet werden.
          </p>
          <p>Sie haben das Recht, von uns die Berichtigung Sie betreffender unrichtiger personenbezogener Daten zu verlangen.</p>
          <p>
            Sie haben das Recht, aus Gründen, die sich aus Ihrer besonderen Situation ergeben, jederzeit gegen die Verarbeitung Sie betreffender
            personenbezogener Daten, die aufgrund von Art. 6 Abs. 1 lit. f DSGVO erfolgt, Widerspruch einzulegen. Wir verarbeiten die personenbezogenen Daten
            dann nicht mehr. Vorbehalten bleibt eine längere Verarbeitung aufgrund spezialgesetzlicher Bestimmungen oder aufgrund drohender oder nicht
            abgeschlossener Rechtstreitigkeiten. Unter bestimmten Voraussetzungen – etwa im Fall einer widerrufenen Einwilligung oder eines Widerspruchs – haben
            Sie das Recht, von uns zu verlangen, dass Sie betreffende personenbezogene Daten unverzüglich gelöscht werden. Vorbehalten bleibt eine längere
            Speicherung aufgrund spezialgesetzlicher Bestimmungen oder aufgrund drohender oder nicht abgeschlossener Rechtstreitigkeiten.
          </p>
          <p>Sie haben das Recht, von uns eine Einschränkung der Verarbeitung zu verlangen, wenn eine der folgenden Voraussetzungen gegeben ist:</p>
          <ul>
            <li>
              die Richtigkeit Sie betreffende personenbezogene Daten von Ihnen bestritten wird, und zwar für eine Dauer, die es uns ermöglicht, die Richtigkeit
              der personenbezogenen Daten zu überprüfen; oder
            </li>
            <li>
              die Verarbeitung unrechtmäßig ist und Sie die Löschung der personenbezogenen Daten ablehnen und stattdessen die Einschränkung der Nutzung der
              personenbezogenen Daten verlangen.
            </li>
          </ul>

          <p>
            Wurde die Verarbeitung eingeschränkt, so dürfen diese personenbezogenen Daten – von ihrer Speicherung abgesehen – nur mit Ihrer Einwilligung oder
            zur Geltendmachung, Ausübung oder Verteidigung von Rechtsansprüchen oder zum Schutz der Rechte einer anderen natürlichen oder juristischen Person
            oder aus Gründen eines wichtigen öffentlichen Interesses verarbeitet werden.
          </p>
          <p>
            Soweit die Verarbeitung personenbezogener Daten auf Ihrer Einwilligung basiert, haben Sie das Recht, die Sie betreffenden personenbezogenen Daten,
            die Sie uns bereitgestellt haben, in einem strukturierten, gängigen und maschinenlesbaren Format zu erhalten. Dabei haben Sie das Recht, zu
            erwirken, dass Ihre personenbezogenen Daten direkt von uns einem anderen Verantwortlichen übermittelt werden, soweit dies technisch machbar ist
            (Datenportabilität).
          </p>
          <p>
            Sie haben als betroffene Person in der EU unbeschadet eines anderweitigen verwaltungsrechtlichen oder gerichtlichen Rechtsbehelfs das Recht auf
            Beschwerde bei einer Aufsichtsbehörde, insbesondere in dem Mitgliedstaat Ihres Aufenthaltsorts, Ihres Arbeitsplatzes oder des Orts des mutmaßlichen
            Verstoßes. Zu Fragen zum Thema Datenschutz können Sie sich jederzeit an uns wenden.
          </p>

          <p>&nbsp;</p>

          <h2>Server-Log-Files</h2>
          <p>
            Unsere Website erhebt und speichert automatisch Informationen in so genannten Server-Log Files, die Ihr Browser automatisch an uns übermittelt. Dies
            sind:
          </p>
          <ul>
            <li>Browsertyp und Browserversion</li>
            <li>verwendetes Betriebssystem</li>
            <li>Referrer URL</li>
            <li>Hostname des zugreifenden Rechners</li>
            <li>Uhrzeit der Serveranfrage</li>
          </ul>
          <p>
            Diese Daten können nicht bestimmten natürlichen Personen zugeordnet werden. Eine Zusammenführung dieser Daten mit anderen Datenquellen wird nicht
            vorgenommen. Wir behalten uns vor, diese Daten nachträglich zu prüfen, wenn uns konkrete Anhaltspunkte für eine rechtswidrige Nutzung bekannt
            werden.
          </p>

          <p>&nbsp;</p>

          <h2>SSL-Verschlüsselung</h2>
          <p>
            Wir nutzen aus Gründen der Sicherheit und zum Schutz der Übertragung vertraulicher Inhalte, wie zum Beispiel der Anfragen, die Sie an uns als
            Websitebetreiber senden, eine SSL-Verschlüsselung. Eine verschlüsselte Verbindung erkennen Sie daran, dass die Adresszeile des Browsers von
            "http://" auf "https://" wechselt und an dem Schloss-Symbol in Ihrer Browserzeile.
          </p>
          <p>Wenn die SSL Verschlüsselung aktiviert ist, können die Daten, die Sie an uns übermitteln, nicht von Dritten mitgelesen werden.</p>
          <p>
            Im Übrigen haben wir technische und organisatorische Sicherheitsmaßnahmen implementiert, um Ihre personenbezogenen Daten gegen unerlaubten Zugriff,
            Missbrauch, Verlust oder Zerstörung zu schützen.
          </p>

          <p>&nbsp;</p>

          <h2>Widerspruch Werbe-Mails</h2>
          <p style="margin-bottom: 0em">
            Der Nutzung von im Rahmen der Impressumspflicht veröffentlichten Kontaktdaten zur Übersendung von nicht ausdrücklich angeforderter Werbung und
            Informationsmaterialien wird hiermit ausdrücklich widersprochen. Wir behalten uns ausdrücklich rechtliche Schritte im Falle der unverlangten
            Zusendung von Werbeinformationen, etwa durch Spam-Mails, vor.
          </p>
        </ng-template>
      </div>
    </div>
  </div>
</div>
